import {
  FETCH_PRODUCTS_SUCCESS,
  refreshPrice,
  REFRESH_PRODUCT_VARIATION,
} from "../actions/productsAction";
import { ADD_REVIEW_TO_PRODUCT } from "../actions/productsAction";

const initState = {
  products: [],
};

const productsReducer = (state = initState, action) => {
  ////console.log("productsreducer " + action.type);
  if (action.type === REFRESH_PRODUCT_VARIATION) {
    var personal = JSON.parse(sessionStorage.getItem("personal"));
    var productNoSco = JSON.parse(sessionStorage.getItem("itemsNoSco") != "undefined"
    ? sessionStorage.getItem("itemsNoSco")
    : "[]");
    var products = state.products;

    if (personal.TipLis == 4)
      products.map((product) => {
        if (productNoSco?.find((p) => p.IDArtBas === product.id))
          return product;
        if (product.id == action.payload.idArt) {
          product.variation = action.payload.variation.map((variation) => {
            return {
              ...variation,
              size: variation.size?.map((size) => {
                return {
                  ...size,
                  pricesco:
                    size.pricesco *
                    (1 - personal.S1 / 100.0) *
                    (1 - personal.S2 / 100.0),
                };
              }),
            };
          });
          return product;
        }
      });
    localStorage.setItem("products", products);
    state.products = products;
    //products = refreshPrice(products, JSON.parse(sessionStorage.getItem("personal")))
  }

  if (action.type === FETCH_PRODUCTS_SUCCESS) {
    return {
      ...state,
      products: action.payload,
      productDescriptions: action.payload2,
    };
  }

  if (action.type === ADD_REVIEW_TO_PRODUCT) {
    var products = state.products;
    var itmRec;
    var Vuoto = true;

    products.map((product) => {
      if (product.id == action.payload.id) {
        if (product.reviews != undefined) {
          for (var prop in product.reviews[0]) {
            if (product.reviews[0].hasOwnProperty(prop)) {
              //console.log(prop);
              Vuoto = false;
            }
          }
        }

        //console.log(Vuoto);
        if (!Vuoto) {
          product.reviews[product.reviews.length] = action.payload;
        } else {
          itmRec = [{ Ciao: 2 }];
          itmRec[0] = action.payload;
          product.reviews[0] = action.payload;
        }
      }
    });
  }

  return state;
};

export default productsReducer;
